import angular from 'angular';

class ModalDeleteCooperativeCtrl {
    /*@ngInject*/
    constructor(CooperativeSvc, logger) {
        this.CooperativeSvc = CooperativeSvc;
        this.logger = logger;
    }

    deleteCoperative() {
        let vm = this;
        this.CooperativeSvc.deleteCooperative(vm.resolve.cooperative.id).then(
            function (data) {
                vm.logger.success('success.delete', data, null, {
                    entityName: vm.resolve.cooperative.name,
                });
                vm.modalInstance.close();
            },
            function () {
                vm.logger.error('error.delete');
                vm.cancel();
            }
        );
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.principal').component('modalDeleteCooperative', {
    templateUrl: require('./modal-delete-cooperative.html'),
    controller: ModalDeleteCooperativeCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
